/**
 * Returns test suite related URLs.
 */
export function getTestSuitesUrls() {
  const baseTestSuitesUrl = '/configurations/test-suites'

  return {
    base: () => baseTestSuitesUrl,
    byIdentifier: (identifier?: string) => `${baseTestSuitesUrl}/${identifier}`,
    new: () => `${baseTestSuitesUrl}/new`,
    testSuiteFormTab: (testSuiteId: string, tab: string) =>
      `${baseTestSuitesUrl}/${testSuiteId}/${tab}`,
    view: (testSuiteId: string) => `${baseTestSuitesUrl}/${testSuiteId}/teams`
  }
}
